module.exports = __webpack_public_path__ + "img/T956.6a4e3940.jpg";